import { render } from "./DiceFloatPreview.vue?vue&type=template&id=ca6aff4e&scoped=true"
import script from "./DiceFloatPreview.vue?vue&type=script&lang=js"
export * from "./DiceFloatPreview.vue?vue&type=script&lang=js"

import "./DiceFloatPreview.vue?vue&type=style&index=0&id=ca6aff4e&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca6aff4e"]])

export default __exports__